module.exports = __webpack_public_path__ + "static/media/r3.88ea7b7e.jpg";